// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exam-tabs-bar {
  display: flex;
  align-items: center;
  padding: 0 var(--space-4);
  border-bottom: 1px solid var(--border-subtle);
  height: 48px;
  min-height: 48px;
  max-height: 48px;
  box-sizing: border-box;
  flex-shrink: 0;
  gap: var(--space-3);
  position: relative;
}

/* Compact density: keep the widgets/exam strip proportional to the compact shell. */
@media (min-width: 1025px) {
  :root[data-ui-density="compact"] .exam-tabs-bar {
    height: 42px;
    min-height: 42px;
    max-height: 42px;
    padding: 0 12px;
    gap: 8px;
  }
}

/* ── Admin workspace nav inside the widgets bar ── */
.eab-admin-workspace-nav {
  display: flex;
  align-items: center;
  gap: 2px;
  height: 100%;
  flex: 1 1;
  min-width: 0;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.eab-admin-workspace-nav::-webkit-scrollbar { display: none; }

.eab-workspace-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 30px;
  padding: 0 12px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.55);
  text-decoration: none;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  transition:
    color 150ms ease,
    border-color 150ms ease,
    background 150ms ease;
  white-space: nowrap;
  flex-shrink: 0;
}

.eab-workspace-pill:hover {
  color: rgba(255, 255, 255, 0.92);
  background: rgba(255, 255, 255, 0.03);
}

.eab-workspace-pill.is-active {
  color: #ffffff;
  border-bottom-color: var(--admin-accent);
  background: rgba(255, 255, 255, 0.02);
}

.eab-workspace-pill__label {
  display: inline-flex;
  align-items: center;
}

.eab-workspace-pill__badge {
  margin-left: 2px;
}

.eab-workspace-pill__badge .au-badge__dot {
  display: none;
}

.eab-workspace-pill--external .eab-workspace-pill__external-glyph {
  font-size: 10px;
  font-weight: 700;
  opacity: 0.55;
  letter-spacing: 0;
  transform: translateY(-1px);
  transition: opacity 150ms ease;
}

.eab-workspace-pill--external:hover .eab-workspace-pill__external-glyph {
  opacity: 0.9;
}

.exam-tabs-bar.exam-tabs-bar--admin {
  position: sticky;
  top: 0;
  z-index: 100;
  justify-content: flex-end;
  padding-inline: var(--admin-shell-pad-x, 2rem);
  background: var(--admin-bg-sunken);
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.28);
}

.exam-tabs-scroll {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  overflow-x: auto;
  flex: 1 1;
  height: 100%;
  min-width: 0;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding: 0;
}

.exam-tabs-scroll::-webkit-scrollbar {
  display: none;
}

.exam-pill {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-height: 30px;
  padding: 0 var(--space-3);
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-family: var(--font-primary);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
  flex-shrink: 0;
}

.exam-pill:hover {
  background: var(--bg-surface);
  color: var(--text-primary);
  border-color: var(--border-subtle);
}

/* Reckoning exam pill — red accent to distinguish from normal exams. */
.exam-pill--reckoning {
  color: rgba(252, 165, 165, 0.92);
  border-color: rgba(239, 68, 68, 0.32);
  background: rgba(239, 68, 68, 0.06);
}

.exam-pill--reckoning:hover {
  background: rgba(239, 68, 68, 0.16);
  color: rgba(254, 226, 226, 1);
  border-color: rgba(239, 68, 68, 0.5);
}

.exam-pill--reckoning.active {
  background: rgba(239, 68, 68, 0.22);
  color: rgba(254, 226, 226, 1);
  border-color: rgba(239, 68, 68, 0.6);
  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.18) inset;
}

.exam-pill-countdown--reckoning {
  background: rgba(239, 68, 68, 0.18);
  color: rgba(254, 226, 226, 1);
}

/* The reckoning end/forfeit control was removed from this bar (2026-06-14);
   abandoning a reckoning now lives in the ContentTray ("Abandon Reckoning"
   ct-orb--danger), alongside exam deletion. The .exam-pill--reckoning-end
   styles were dropped with it. */

.exam-pill.active {
  background: var(--bg-surface);
  border-color: var(--accent-primary);
  color: var(--text-primary);
  font-weight: var(--font-weight-semibold);
  box-shadow: 0 0 0 1px var(--accent-primary-muted);
}

.exam-pill-title {
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:root[data-ui-density="compact"] .exam-pill-title {
  max-width: clamp(100px, 8vw, 140px);
}

.exam-pill-countdown {
  font-size: var(--text-xs);
  font-weight: var(--font-weight-bold);
  padding: 1px 6px;
  border-radius: var(--radius-sm);
  line-height: 1.4;
  cursor: pointer;
}

.exam-pill-countdown.countdown-normal {
  color: var(--color-success);
  background: rgba(34, 197, 94, 0.1);
}

.exam-pill-countdown.countdown-soon {
  color: var(--color-warning);
  background: rgba(245, 158, 11, 0.1);
}

.exam-pill-countdown.countdown-urgent {
  color: var(--color-error);
  background: var(--color-error-bg);
}

.exam-pill-countdown.countdown-revived {
  color: rgb(168, 85, 247);
  background: rgba(168, 85, 247, 0.1);
}

.exam-pill-countdown.countdown-revived:hover {
  background: rgba(168, 85, 247, 0.2);
}

.exam-pill.completed {
  opacity: 0.6;
}

.exam-pill.completed:hover {
  opacity: 0.85;
}

.exam-pill.completed.active {
  opacity: 1;
}

.exam-pill-countdown.countdown-completed {
  color: var(--text-tertiary);
  background: rgba(255, 255, 255, 0.06);
}

.exam-tabs-actions {
  display: flex;
  align-items: center;
  height: 100%;
  gap: var(--space-2);
  flex-shrink: 0;
  /* Pin to the right edge of .exam-tabs-bar. Needed because the left slot
     .exam-tabs-scroll (flex:1) is conditionally rendered only when the user
     has upcoming exams; without this, an unmounted left slot lets the action
     cluster fall back to flex-start at x=0. */
  margin-left: auto;
}

.upgrade-button {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 8px;
  background: rgba(59, 130, 246, 0.12);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 4px;
  color: #60a5fa;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 150ms ease;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.upgrade-button:hover {
  background: rgba(59, 130, 246, 0.2);
  border-color: rgba(59, 130, 246, 0.35);
  color: #93c5fd;
}

.upgrade-button:active {
  opacity: 0.8;
}

.premium-badge {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 28px;
  padding: 0 8px;
  margin-right: 0.75rem;
  border-radius: 4px;
  background: rgba(251, 191, 36, 0.1);
  border: 1px solid rgba(251, 191, 36, 0.2);
  color: #fbbf24;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  flex-shrink: 0;
}

.help-codex-nav-button,
.settings-nav-button,
.feature-request-nav-button,
.bug-report-nav-button,
.share-demo-nav-button,
.admin-nav-button {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.05);
  border: none;
  padding: 0;
  flex-shrink: 0;
  /* Always-on chrome — popups like DiscoveryModal sit at z-index 10000 and
     used to occlude the bug-report path. Lift the action-bar buttons above
     overlay popups so users can always reach help / bug / settings. The
     BugReportModal itself uses z-index: 20000 so it ends up on top once open. */
  position: relative;
  z-index: 12000;
}

/* Dev Portal nav button — owner verifier admin-shell surface, EKG accent */
.dev-portal-nav-button {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: rgba(239, 68, 68, 0.85);
  cursor: pointer;
  transition: all 0.15s ease;
  background: rgba(239, 68, 68, 0.06);
  border: 1px solid rgba(239, 68, 68, 0.28);
  padding: 0;
  flex-shrink: 0;
  text-decoration: none;
}
.dev-portal-nav-button:hover {
  color: rgba(255, 110, 110, 1);
  background: rgba(239, 68, 68, 0.14);
  border-color: rgba(239, 68, 68, 0.5);
}
.dev-portal-nav-button svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  filter: drop-shadow(0 0 3px rgba(239, 68, 68, 0.45));
  transition: filter 150ms ease;
}
.dev-portal-nav-button:hover svg {
  filter: drop-shadow(0 0 5px rgba(239, 68, 68, 0.7));
}

/* Developer dev-port button — appears when user.developer_dev_port is set.
   Sits between bug-report and settings. Green accent (distinct from Shay's
   red owner-verifier button). 32x32 to match the surrounding row. */
.developer-dev-button {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: rgba(110, 231, 183, 0.9);
  cursor: pointer;
  transition: all 0.15s ease;
  background: rgba(16, 185, 129, 0.08);
  border: 1px solid rgba(16, 185, 129, 0.32);
  padding: 0;
  flex-shrink: 0;
  text-decoration: none;
}
.developer-dev-button:hover {
  color: rgba(167, 243, 208, 1);
  background: rgba(16, 185, 129, 0.16);
  border-color: rgba(16, 185, 129, 0.55);
}
.developer-dev-button svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  filter: drop-shadow(0 0 3px rgba(16, 185, 129, 0.4));
  transition: filter 150ms ease;
}
.developer-dev-button:hover svg {
  filter: drop-shadow(0 0 5px rgba(16, 185, 129, 0.65));
}

.help-codex-nav-button:hover,
.settings-nav-button:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
}

.feature-request-nav-button:hover {
  color: #fbbf24;
  background: rgba(251, 191, 36, 0.1);
}

.bug-report-nav-button:hover {
  color: #fb923c;
  background: rgba(251, 146, 60, 0.1);
}

.share-demo-nav-button:hover {
  color: #60a5fa;
  background: rgba(96, 165, 250, 0.1);
}

.admin-nav-button:hover {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.help-codex-nav-button svg,
.settings-nav-button svg,
.feature-request-nav-button svg,
.bug-report-nav-button svg,
.share-demo-nav-button svg,
.admin-nav-button svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.admin-nav-button--active {
  color: #ffffff;
  background: rgba(239, 68, 68, 0.16);
  box-shadow: inset 0 0 0 1px rgba(239, 68, 68, 0.28);
}

.admin-nav-button--active:hover {
  background: rgba(239, 68, 68, 0.22);
}

.logout-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.logout-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.05);
}

.logout-button:hover .logout-icon {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

@media (max-width: 1024px) {
  .exam-tabs-bar {
    flex-wrap: wrap;
    height: auto;
    min-height: 72px;
    max-height: none;
    padding: var(--space-1) var(--space-3);
    align-content: center;
    row-gap: var(--space-1);
  }

  .exam-tabs-bar--admin {
    flex-wrap: nowrap;
    height: 48px;
    min-height: 48px;
    max-height: 48px;
  }

  .exam-tabs-scroll {
    order: 1;
    width: 100%;
    height: auto;
    min-height: 28px;
  }

  .exam-tabs-actions {
    order: 2;
    width: 100%;
    height: auto;
    justify-content: flex-end;
    min-height: 28px;
  }

  .exam-tabs-bar--admin .exam-tabs-actions {
    width: auto;
    min-height: 100%;
  }

  .upgrade-button,
  .premium-badge {
    padding: 0 0.6rem;
    font-size: 0.7rem;
    margin-right: 0.25rem;
  }

  .help-codex-nav-button,
  .settings-nav-button,
  .feature-request-nav-button,
  .bug-report-nav-button,
  .share-demo-nav-button,
  .admin-nav-button {
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
  }

  .help-codex-nav-button svg,
  .settings-nav-button svg,
  .feature-request-nav-button svg,
  .bug-report-nav-button svg,
  .share-demo-nav-button svg,
  .admin-nav-button svg {
    width: 16px;
    height: 16px;
  }
}

@media (max-width: 480px) {
  .exam-pill-title {
    max-width: 100px;
  }
}

/* ─── Septyx dev admin button (dev4 only) ────────── */
.septyx-nav-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.35);
  border-radius: 10px;
  color: rgba(239, 68, 68, 0.9);
  cursor: pointer;
  transition: all 150ms ease;
  font-family: inherit;
  position: relative;
}

.septyx-nav-button::after {
  content: '';
  position: absolute;
  top: -2px;
  right: -2px;
  width: 7px;
  height: 7px;
  background: rgba(239, 68, 68, 0.95);
  border-radius: 50%;
  border: 2px solid #06080b;
  box-shadow: 0 0 6px rgba(239, 68, 68, 0.7);
}

.septyx-nav-button:hover {
  background: rgba(239, 68, 68, 0.15);
  border-color: rgba(239, 68, 68, 0.6);
  color: rgba(254, 202, 202, 1);
  transform: translateY(-1px);
}

.septyx-nav-button--active {
  background: rgba(239, 68, 68, 0.18);
  border-color: rgba(239, 68, 68, 0.7);
  color: rgba(254, 202, 202, 1);
  box-shadow: 0 0 16px -4px rgba(239, 68, 68, 0.5);
}
`, "",{"version":3,"sources":["webpack://./src/components/UserActionBar/UserActionBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oFAAoF;AACpF;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,QAAQ;EACV;AACF;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,8CAA8C,aAAa,EAAE;;AAE7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,gBAAgB;EAChB;;;yBAGuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,yBAAyB;EACzB,8CAA8C;EAC9C,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,yBAAyB;EACzB,sCAAsC;EACtC,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,uEAAuE;AACvE;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,mDAAmD;AACrD;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;;;iCAGiC;;AAEjC;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,0BAA0B;EAC1B,wCAAwC;EACxC,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd;;;8CAG4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;EACZ,UAAU;EACV,cAAc;EACd;;;gFAG8E;EAC9E,kBAAkB;EAClB,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,yCAAyC;EACzC,UAAU;EACV,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oDAAoD;EACpD,6BAA6B;AAC/B;AACA;EACE,mDAAmD;AACrD;;AAEA;;oEAEoE;AACpE;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,oCAAoC;EACpC,0CAA0C;EAC1C,UAAU;EACV,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oDAAoD;EACpD,6BAA6B;AAC/B;AACA;EACE,qDAAqD;AACvD;;AAEA;;EAEE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;;;;;;EAME,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,mDAAmD;AACrD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,sCAAsC;IACtC,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;;;;;;IAME,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;;;;IAME,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,uDAAuD;AACvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,6BAA6B;EAC7B,gDAAgD;AAClD","sourcesContent":[".exam-tabs-bar {\n  display: flex;\n  align-items: center;\n  padding: 0 var(--space-4);\n  border-bottom: 1px solid var(--border-subtle);\n  height: 48px;\n  min-height: 48px;\n  max-height: 48px;\n  box-sizing: border-box;\n  flex-shrink: 0;\n  gap: var(--space-3);\n  position: relative;\n}\n\n/* Compact density: keep the widgets/exam strip proportional to the compact shell. */\n@media (min-width: 1025px) {\n  :root[data-ui-density=\"compact\"] .exam-tabs-bar {\n    height: 42px;\n    min-height: 42px;\n    max-height: 42px;\n    padding: 0 12px;\n    gap: 8px;\n  }\n}\n\n/* ── Admin workspace nav inside the widgets bar ── */\n.eab-admin-workspace-nav {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  height: 100%;\n  flex: 1;\n  min-width: 0;\n  overflow-x: auto;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.eab-admin-workspace-nav::-webkit-scrollbar { display: none; }\n\n.eab-workspace-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 30px;\n  padding: 0 12px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.55);\n  text-decoration: none;\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  border-radius: 0;\n  transition:\n    color 150ms ease,\n    border-color 150ms ease,\n    background 150ms ease;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.eab-workspace-pill:hover {\n  color: rgba(255, 255, 255, 0.92);\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.eab-workspace-pill.is-active {\n  color: #ffffff;\n  border-bottom-color: var(--admin-accent);\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.eab-workspace-pill__label {\n  display: inline-flex;\n  align-items: center;\n}\n\n.eab-workspace-pill__badge {\n  margin-left: 2px;\n}\n\n.eab-workspace-pill__badge .au-badge__dot {\n  display: none;\n}\n\n.eab-workspace-pill--external .eab-workspace-pill__external-glyph {\n  font-size: 10px;\n  font-weight: 700;\n  opacity: 0.55;\n  letter-spacing: 0;\n  transform: translateY(-1px);\n  transition: opacity 150ms ease;\n}\n\n.eab-workspace-pill--external:hover .eab-workspace-pill__external-glyph {\n  opacity: 0.9;\n}\n\n.exam-tabs-bar.exam-tabs-bar--admin {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  justify-content: flex-end;\n  padding-inline: var(--admin-shell-pad-x, 2rem);\n  background: var(--admin-bg-sunken);\n  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.28);\n}\n\n.exam-tabs-scroll {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  overflow-x: auto;\n  flex: 1;\n  height: 100%;\n  min-width: 0;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  padding: 0;\n}\n\n.exam-tabs-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.exam-pill {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  min-height: 30px;\n  padding: 0 var(--space-3);\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: var(--radius-md);\n  color: var(--text-secondary);\n  font-family: var(--font-primary);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.exam-pill:hover {\n  background: var(--bg-surface);\n  color: var(--text-primary);\n  border-color: var(--border-subtle);\n}\n\n/* Reckoning exam pill — red accent to distinguish from normal exams. */\n.exam-pill--reckoning {\n  color: rgba(252, 165, 165, 0.92);\n  border-color: rgba(239, 68, 68, 0.32);\n  background: rgba(239, 68, 68, 0.06);\n}\n\n.exam-pill--reckoning:hover {\n  background: rgba(239, 68, 68, 0.16);\n  color: rgba(254, 226, 226, 1);\n  border-color: rgba(239, 68, 68, 0.5);\n}\n\n.exam-pill--reckoning.active {\n  background: rgba(239, 68, 68, 0.22);\n  color: rgba(254, 226, 226, 1);\n  border-color: rgba(239, 68, 68, 0.6);\n  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.18) inset;\n}\n\n.exam-pill-countdown--reckoning {\n  background: rgba(239, 68, 68, 0.18);\n  color: rgba(254, 226, 226, 1);\n}\n\n/* The reckoning end/forfeit control was removed from this bar (2026-06-14);\n   abandoning a reckoning now lives in the ContentTray (\"Abandon Reckoning\"\n   ct-orb--danger), alongside exam deletion. The .exam-pill--reckoning-end\n   styles were dropped with it. */\n\n.exam-pill.active {\n  background: var(--bg-surface);\n  border-color: var(--accent-primary);\n  color: var(--text-primary);\n  font-weight: var(--font-weight-semibold);\n  box-shadow: 0 0 0 1px var(--accent-primary-muted);\n}\n\n.exam-pill-title {\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n:root[data-ui-density=\"compact\"] .exam-pill-title {\n  max-width: clamp(100px, 8vw, 140px);\n}\n\n.exam-pill-countdown {\n  font-size: var(--text-xs);\n  font-weight: var(--font-weight-bold);\n  padding: 1px 6px;\n  border-radius: var(--radius-sm);\n  line-height: 1.4;\n  cursor: pointer;\n}\n\n.exam-pill-countdown.countdown-normal {\n  color: var(--color-success);\n  background: rgba(34, 197, 94, 0.1);\n}\n\n.exam-pill-countdown.countdown-soon {\n  color: var(--color-warning);\n  background: rgba(245, 158, 11, 0.1);\n}\n\n.exam-pill-countdown.countdown-urgent {\n  color: var(--color-error);\n  background: var(--color-error-bg);\n}\n\n.exam-pill-countdown.countdown-revived {\n  color: rgb(168, 85, 247);\n  background: rgba(168, 85, 247, 0.1);\n}\n\n.exam-pill-countdown.countdown-revived:hover {\n  background: rgba(168, 85, 247, 0.2);\n}\n\n.exam-pill.completed {\n  opacity: 0.6;\n}\n\n.exam-pill.completed:hover {\n  opacity: 0.85;\n}\n\n.exam-pill.completed.active {\n  opacity: 1;\n}\n\n.exam-pill-countdown.countdown-completed {\n  color: var(--text-tertiary);\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.exam-tabs-actions {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  gap: var(--space-2);\n  flex-shrink: 0;\n  /* Pin to the right edge of .exam-tabs-bar. Needed because the left slot\n     .exam-tabs-scroll (flex:1) is conditionally rendered only when the user\n     has upcoming exams; without this, an unmounted left slot lets the action\n     cluster fall back to flex-start at x=0. */\n  margin-left: auto;\n}\n\n.upgrade-button {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 0 8px;\n  background: rgba(59, 130, 246, 0.12);\n  border: 1px solid rgba(59, 130, 246, 0.2);\n  border-radius: 4px;\n  color: #60a5fa;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 150ms ease;\n  margin-right: 0.75rem;\n  flex-shrink: 0;\n}\n\n.upgrade-button:hover {\n  background: rgba(59, 130, 246, 0.2);\n  border-color: rgba(59, 130, 246, 0.35);\n  color: #93c5fd;\n}\n\n.upgrade-button:active {\n  opacity: 0.8;\n}\n\n.premium-badge {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-height: 28px;\n  padding: 0 8px;\n  margin-right: 0.75rem;\n  border-radius: 4px;\n  background: rgba(251, 191, 36, 0.1);\n  border: 1px solid rgba(251, 191, 36, 0.2);\n  color: #fbbf24;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  flex-shrink: 0;\n}\n\n.help-codex-nav-button,\n.settings-nav-button,\n.feature-request-nav-button,\n.bug-report-nav-button,\n.share-demo-nav-button,\n.admin-nav-button {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  min-height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: rgba(255, 255, 255, 0.05);\n  border: none;\n  padding: 0;\n  flex-shrink: 0;\n  /* Always-on chrome — popups like DiscoveryModal sit at z-index 10000 and\n     used to occlude the bug-report path. Lift the action-bar buttons above\n     overlay popups so users can always reach help / bug / settings. The\n     BugReportModal itself uses z-index: 20000 so it ends up on top once open. */\n  position: relative;\n  z-index: 12000;\n}\n\n/* Dev Portal nav button — owner verifier admin-shell surface, EKG accent */\n.dev-portal-nav-button {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  min-height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: rgba(239, 68, 68, 0.85);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  background: rgba(239, 68, 68, 0.06);\n  border: 1px solid rgba(239, 68, 68, 0.28);\n  padding: 0;\n  flex-shrink: 0;\n  text-decoration: none;\n}\n.dev-portal-nav-button:hover {\n  color: rgba(255, 110, 110, 1);\n  background: rgba(239, 68, 68, 0.14);\n  border-color: rgba(239, 68, 68, 0.5);\n}\n.dev-portal-nav-button svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  filter: drop-shadow(0 0 3px rgba(239, 68, 68, 0.45));\n  transition: filter 150ms ease;\n}\n.dev-portal-nav-button:hover svg {\n  filter: drop-shadow(0 0 5px rgba(239, 68, 68, 0.7));\n}\n\n/* Developer dev-port button — appears when user.developer_dev_port is set.\n   Sits between bug-report and settings. Green accent (distinct from Shay's\n   red owner-verifier button). 32x32 to match the surrounding row. */\n.developer-dev-button {\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  min-height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: rgba(110, 231, 183, 0.9);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  background: rgba(16, 185, 129, 0.08);\n  border: 1px solid rgba(16, 185, 129, 0.32);\n  padding: 0;\n  flex-shrink: 0;\n  text-decoration: none;\n}\n.developer-dev-button:hover {\n  color: rgba(167, 243, 208, 1);\n  background: rgba(16, 185, 129, 0.16);\n  border-color: rgba(16, 185, 129, 0.55);\n}\n.developer-dev-button svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  filter: drop-shadow(0 0 3px rgba(16, 185, 129, 0.4));\n  transition: filter 150ms ease;\n}\n.developer-dev-button:hover svg {\n  filter: drop-shadow(0 0 5px rgba(16, 185, 129, 0.65));\n}\n\n.help-codex-nav-button:hover,\n.settings-nav-button:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.feature-request-nav-button:hover {\n  color: #fbbf24;\n  background: rgba(251, 191, 36, 0.1);\n}\n\n.bug-report-nav-button:hover {\n  color: #fb923c;\n  background: rgba(251, 146, 60, 0.1);\n}\n\n.share-demo-nav-button:hover {\n  color: #60a5fa;\n  background: rgba(96, 165, 250, 0.1);\n}\n\n.admin-nav-button:hover {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.help-codex-nav-button svg,\n.settings-nav-button svg,\n.feature-request-nav-button svg,\n.bug-report-nav-button svg,\n.share-demo-nav-button svg,\n.admin-nav-button svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.admin-nav-button--active {\n  color: #ffffff;\n  background: rgba(239, 68, 68, 0.16);\n  box-shadow: inset 0 0 0 1px rgba(239, 68, 68, 0.28);\n}\n\n.admin-nav-button--active:hover {\n  background: rgba(239, 68, 68, 0.22);\n}\n\n.logout-button {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.logout-icon {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.logout-button:hover .logout-icon {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n}\n\n@media (max-width: 1024px) {\n  .exam-tabs-bar {\n    flex-wrap: wrap;\n    height: auto;\n    min-height: 72px;\n    max-height: none;\n    padding: var(--space-1) var(--space-3);\n    align-content: center;\n    row-gap: var(--space-1);\n  }\n\n  .exam-tabs-bar--admin {\n    flex-wrap: nowrap;\n    height: 48px;\n    min-height: 48px;\n    max-height: 48px;\n  }\n\n  .exam-tabs-scroll {\n    order: 1;\n    width: 100%;\n    height: auto;\n    min-height: 28px;\n  }\n\n  .exam-tabs-actions {\n    order: 2;\n    width: 100%;\n    height: auto;\n    justify-content: flex-end;\n    min-height: 28px;\n  }\n\n  .exam-tabs-bar--admin .exam-tabs-actions {\n    width: auto;\n    min-height: 100%;\n  }\n\n  .upgrade-button,\n  .premium-badge {\n    padding: 0 0.6rem;\n    font-size: 0.7rem;\n    margin-right: 0.25rem;\n  }\n\n  .help-codex-nav-button,\n  .settings-nav-button,\n  .feature-request-nav-button,\n  .bug-report-nav-button,\n  .share-demo-nav-button,\n  .admin-nav-button {\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n    min-height: 32px;\n  }\n\n  .help-codex-nav-button svg,\n  .settings-nav-button svg,\n  .feature-request-nav-button svg,\n  .bug-report-nav-button svg,\n  .share-demo-nav-button svg,\n  .admin-nav-button svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .exam-pill-title {\n    max-width: 100px;\n  }\n}\n\n/* ─── Septyx dev admin button (dev4 only) ────────── */\n.septyx-nav-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  background: rgba(239, 68, 68, 0.08);\n  border: 1px solid rgba(239, 68, 68, 0.35);\n  border-radius: 10px;\n  color: rgba(239, 68, 68, 0.9);\n  cursor: pointer;\n  transition: all 150ms ease;\n  font-family: inherit;\n  position: relative;\n}\n\n.septyx-nav-button::after {\n  content: '';\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 7px;\n  height: 7px;\n  background: rgba(239, 68, 68, 0.95);\n  border-radius: 50%;\n  border: 2px solid #06080b;\n  box-shadow: 0 0 6px rgba(239, 68, 68, 0.7);\n}\n\n.septyx-nav-button:hover {\n  background: rgba(239, 68, 68, 0.15);\n  border-color: rgba(239, 68, 68, 0.6);\n  color: rgba(254, 202, 202, 1);\n  transform: translateY(-1px);\n}\n\n.septyx-nav-button--active {\n  background: rgba(239, 68, 68, 0.18);\n  border-color: rgba(239, 68, 68, 0.7);\n  color: rgba(254, 202, 202, 1);\n  box-shadow: 0 0 16px -4px rgba(239, 68, 68, 0.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
